import React from 'react';
import { roadMapData } from '../../data/disclosureRequest';
import type { Density, RoadMapSection } from '../../types/disclosure';
import { RoadMapHeader } from './RoadMapHeader';
import { SectionCard } from './SectionCard';
import { FieldGroupBlock } from './FieldGroupBlock';
import { NotApplicableGroups } from './NotApplicableGroups';
import { NotesPanel } from './NotesPanel';
interface RoadMapTabProps {
  density: Density;
  showApiNames: boolean;
}
export function RoadMapTab({
  density,
  showApiNames
}: RoadMapTabProps) {
  const {
    header,
    sections,
    notesSection
  } = roadMapData;
  const findSection = (id: string) => sections.find(section => section.id === id) as RoadMapSection;
  const contacts = findSection('required-contacts');
  const property = findSection('property-transaction');
  const product = findSection('loan-product');
  const disclosure = findSection('disclosure-details');
  const renderSection = (section: RoadMapSection, columns: 1 | 2 | 3) => {
    const applicable = section.groups.filter(group => group.applicable !== false);
    const notApplicable = section.groups.filter(group => group.applicable === false);
    return <SectionCard id={section.id} number={section.number} title={section.title} description={section.description} data-id="element-74" data-mp="2liaxqftzm2ps">
        {applicable.map(group => <FieldGroupBlock key={group.id} group={group} density={density} showApiNames={showApiNames} columns={columns} data-id="element-75" data-mp="2uetq9qyb3olu" />)}
        <NotApplicableGroups groups={notApplicable} sectionId={section.id} data-id="element-76" data-mp="22nnnf2r7bcsv" />
      </SectionCard>;
  };
  return <main className="min-h-full w-full bg-slate-100 px-3 py-4 sm:px-5 lg:px-6" data-id="element-77" data-mp="2bm7ypiufmk72">
      <div className="mx-auto max-w-[1600px] space-y-3" data-id="element-78" data-mp="2bk4xs3rqr6nk">
        <RoadMapHeader data={header} data-id="element-79" data-mp="3i19zkwy86xx2" />

        <div className="grid items-start gap-3 xl:grid-cols-3" data-id="element-80" data-mp="3i4ebyhlugzyt">
          <div className="xl:col-span-2" data-id="element-81" data-mp="3n0d1w9mtmq1c">{renderSection(contacts, 2)}</div>
          <div className="space-y-3" data-id="element-82" data-mp="1mylxwaccog3i">
            {renderSection(property, 1)}
            {renderSection(product, 1)}
          </div>
        </div>

        {renderSection(disclosure, 3)}

        <SectionCard id={notesSection.id} number={notesSection.number} title={notesSection.title} description={notesSection.description} data-id="element-83" data-mp="1wx2sdhahzcub">
          <NotesPanel notes={notesSection.notes} showApiNames={showApiNames} data-id="element-84" data-mp="148ni182b9ipb" />
        </SectionCard>
      </div>
    </main>;
}